import React from 'react';
import { HeaderPage } from '../../../components/HeaderPage/HeaderPage';
import { DASHBOARD_ROUTES } from '../../../Routes';
import { useParams } from 'react-router-dom';
import { CompanyInfo } from '../../../data/models/company.model';
import { useSelector } from 'react-redux';
import { selectCompany } from '../../../store/companySlide';
import { DetailFormCompany } from '../components/DetailFormCompany';
import { Tab } from 'interface/tab.interface';

export enum TabEnum {
  Overview = 'Overview',
  Users = 'Users',
  BranchLocations = 'Branch Locations',
  EscalationProtocol = 'Escalation Protocol',
  CompanyNotes = 'Company Notes',
  AiContext = 'AI Context',
  UsageLogs = 'Usage Logs',
  OutreachReport = 'Outreach Report',
}

export const handleTabs = (
  companyId: string,
  isParentCompany: boolean,
  title: string,
) => {
  const tabs = [
    {
      title: TabEnum.Overview,
      selected: title === TabEnum.Overview,
      link: DASHBOARD_ROUTES.COMPANY_DETAIL + companyId,
    },
    {
      title: TabEnum.Users,
      selected: title === TabEnum.Users,
      link: DASHBOARD_ROUTES.COMPANY_ID_EMPLOYEES(companyId),
    },
    {
      title: TabEnum.BranchLocations,
      selected: title === TabEnum.BranchLocations,
      link: DASHBOARD_ROUTES.COMPANY_BRANCH_LOCATIONS(companyId),
    },
    {
      title: TabEnum.EscalationProtocol,
      selected: title === TabEnum.EscalationProtocol,
      link: DASHBOARD_ROUTES.COMPANY_ID_ESCALATION(companyId),
    },
    {
      title: TabEnum.CompanyNotes,
      selected: title === TabEnum.CompanyNotes,
      link: DASHBOARD_ROUTES.COMPANY_ID_NOTES(companyId),
    },
    {
      title: TabEnum.AiContext,
      selected: title === TabEnum.AiContext,
      link: DASHBOARD_ROUTES.COMPANY_ID_AI_CONTEXT(companyId),
    },
    {
      title: TabEnum.UsageLogs,
      selected: title === TabEnum.UsageLogs,
      link: DASHBOARD_ROUTES.COMPANY_ID_TRACKING(companyId),
    },
    {
      title: TabEnum.OutreachReport,
      selected: title === TabEnum.OutreachReport,
      link: DASHBOARD_ROUTES.COMPANY_ID_MESSAGES_SENT(companyId),
    },
  ];
  return isParentCompany
    ? tabs
    : tabs.filter((i: Tab) => {
        if (i.title !== TabEnum.BranchLocations) {
          return i;
        }
      });
};

const CompanyDetailNew = () => {
  const { company_id } = useParams();
  const companyInfo: CompanyInfo = useSelector(selectCompany);

  return (
    <>
      <HeaderPage
        title={{
          title: companyInfo?.name ? companyInfo?.name : '',
          hasBack: true,
        }}
        tabs={handleTabs(
          company_id || '',
          companyInfo?.isParentCompany || false,
          TabEnum.Overview,
        )}
      />

      <div className="nv-container">
        <DetailFormCompany />
      </div>
    </>
  );
};

export default CompanyDetailNew;
